import { login, logout, getInfo, getMenuList } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),//token
    userInfo: '',//用户信息
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER_INFO: (state, info) => {
      state.userInfo = info;
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
          login(username, userInfo.password,userInfo.companyType,userInfo.briefName).then(response => {
          // console.log("登录成功Token===>" + response.token)
          const data = response;
          const tokenStr = data.token;
          setToken(tokenStr);
          commit('SET_TOKEN', tokenStr);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data;
          // console.log('用户信息===>', data);
          commit('SET_USER_INFO', data);
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      commit('SET_TOKEN', '');
      commit('SET_USER_INFO', {});
      localStorage.clear()
      removeToken();
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        sessionStorage.clear()
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js